<!-- Button -->
<button mat-icon-button [matTooltip]="tooltip || 'Toggle Fullscreen'" (click)="toggleFullscreen()">
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <fa-icon [icon]="['fal', 'expand']" class="icon-size-5"></fa-icon>
</ng-template>
